import { forwardRef, HTMLProps } from 'react';

export interface StateProps extends HTMLProps<HTMLDivElement> {
  name: string;
}

function DisplayerErrorMessage(
  { name, ...props }: StateProps,
  ref: React.Ref<HTMLDivElement>
) {
  return (
    <div
      {...props}
      ref={ref}
      className={`state ${props.className || ''}`.trim()}
    >
      <h3>{name}</h3>
      <p>Echec de création de l'élément</p>
    </div>
  );
}

export default forwardRef(DisplayerErrorMessage);
